import { createSlice } from '@reduxjs/toolkit';
// utils
import axios from '../../utils/axios';

// ----------------------------------------------------------------------

function objFromArray(array, key = 'id') {
  return array.reduce((accumulator, current) => {
    accumulator[current[key]] = current;
    return accumulator;
  }, {});
}

const initialState = {
  isLoading: false,
  error: false,

  coloniasVnecedor: null,
  coloniaOrigenVencedor: null,
  coloniaDestinoVencedor: null,
  resultTarifaVencedor: null,

  shipping_type: 1
};

const slice = createSlice({
  name: 'dagpacketVencedor',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    setColoniasVencedor(state, action) {
      state.coloniasVnecedor = action.payload;
    },

    setColiniaOrigenVencedor(state, action) {
      state.coloniaOrigenVencedor = action.payload;
    },

    setColiniaDestinoVencedor(state, action) {
      state.coloniaDestinoVencedor = action.payload;
    },

    resetColoniasVencedor(state) {
      state.coloniasVnecedor = null;
    },

    resetColoniasVencedorOrigeDestino(state) {
      state.coloniaOrigenVencedor = null;
      state.coloniaDestinoVencedor = null;
    },

    setResultTarifaVencedor(state, action) {
      const data = action.payload;

      state.resultTarifaVencedor = data;
    },
    setShippingType(state, action) {
      const data = action.payload;

      state.shipping_type = data;
    }
  }
});

// Reducer
export default slice.reducer;

export const {
  setColoniasVencedor,
  setColiniaOrigenVencedor,
  setColiniaDestinoVencedor,
  resetColoniasVencedor,
  resetColoniasVencedorOrigeDestino,
  setResultTarifaVencedor,
  setShippingType
} = slice.actions;

// ----------------------------------------------------------------------

export const resetFlujoVencedor = () => (dispatch) => {
  dispatch(resetColoniasVencedorOrigeDestino());
  dispatch(resetColoniasVencedor());
  dispatch(setResultTarifaVencedor(null));
};

// export const removeItemProducts = (id) => (dispatch) => {
//   dispatch(slice.actions.removeItem(id));
//   dispatch(slice.actions.calcSubtotal());
// };

// export const restartCartProducts = (item) => (dispatch) => {
//   dispatch(slice.actions.restartCartProducts(item));
//   dispatch(slice.actions.calcSubtotal());
// };
